import React from 'react';
import { classNames } from '../../utils/helpers';

const Card = ({ 
  children, 
  className = '', 
  padding = 'default',
  variant = 'default',
  hover = false,
  glow = false,
  ...props 
}) => {
  const paddingClasses = {
    none: '',
    xs: 'p-2',
    sm: 'p-4',
    default: 'p-6',
    lg: 'p-8',
    xl: 'p-10',
  };

  const variantClasses = {
    default: 'bg-white/80 backdrop-blur-xl rounded-2xl shadow-xl border border-white/20',
    glass: 'bg-white/10 backdrop-blur-xl rounded-2xl shadow-2xl border border-white/10',
    dark: 'bg-slate-800/80 backdrop-blur-xl rounded-2xl shadow-2xl border border-white/5 text-white',
    gradient: 'bg-gradient-to-br from-white/90 to-gray-50/80 backdrop-blur-xl rounded-2xl shadow-2xl border border-white/20',
    elevated: 'bg-white rounded-2xl shadow-2xl border border-gray-100',
  };

  const classes = classNames(
    variantClasses[variant],
    paddingClasses[padding],
    hover && 'hover:shadow-2xl hover:scale-[1.02] hover:-translate-y-1 transition-all duration-300 cursor-pointer',
    glow && 'hover:shadow-cyan-500/50',
    'relative overflow-hidden',
    className
  );

  return (
    <div className={classes} {...props}>
      {glow && (
        <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/10 via-transparent to-blue-500/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
      )}
      <div className="relative z-10">
        {children}
      </div>
    </div>
  );
};

export default Card;